const DEFAULT_SUPPORT = {
  phone: '866-224-2194',
  email: 'qwsupport@lendingtree.com',
  hours: 'Monday-Thursday 7:30am-4:30pm PST, Fridays 7:30am-3:30pm PST',
};

const DEFAULT_ELITE_HOURS = 'Monday-Friday 7:30am-4:30pm PST';

const SupportTeams = {
  '048807AD-54A3-4CAE-9B46-B886035A3BD6': {
    ...DEFAULT_SUPPORT,
    name: 'BEAR',
    phone: '855-725-2851',
  },
  '7E895022-D25F-44B7-AB56-43B569D694D2': {
    ...DEFAULT_SUPPORT,
    name: 'CSG TEAM',
  },
  '151FFD44-DDF0-47AC-879B-4E4E0F03E08D': {
    ...DEFAULT_SUPPORT,
    name: 'DOLPHIN',
    phone: '855-725-2849',
  },
  'DD8FC361-53CE-4843-BF75-6C3E00350A30': {
    ...DEFAULT_SUPPORT,
    name: 'EAGLE',
    phone: '855-725-2864',
  },
  '8BB5F540-4822-4928-BEFE-06CAE0A7C016': {
    ...DEFAULT_SUPPORT,
    name: 'ELITE EAST',
    phone: '855-462-5306',
    hours: DEFAULT_ELITE_HOURS,
  },
  '9F60621C-C9C3-4B5C-8D6A-AAF6FCFCC873': {
    ...DEFAULT_SUPPORT,
    name: 'ELITE MIDWEST',
    phone: '855-462-5304',
    hours: DEFAULT_ELITE_HOURS,
  },
  '1DB3CF2C-5290-4317-A2C9-AFF52F48CB68': {
    ...DEFAULT_SUPPORT,
    name: 'ELITE PRIME',
    phone: '855-247-3362',
    hours: DEFAULT_ELITE_HOURS,
  },
  '1E2A60F7-5975-486D-8D55-445162BCE7C5': {
    ...DEFAULT_SUPPORT,
    name: 'ELITE SOUTH',
    phone: '855-462-5307',
    hours: DEFAULT_ELITE_HOURS,
  },
  'D93DE763-2AC3-4559-A788-BDAFA6BC718A': {
    ...DEFAULT_SUPPORT,
    name: 'ELITE VIP',
    phone: '855-462-5304',
    hours: DEFAULT_ELITE_HOURS,
  },
  '3DB4BA7E-0422-4866-A18D-23ED96DBD0F4': {
    ...DEFAULT_SUPPORT,
    name: 'ELITE WEST',
    phone: '855-462-2380',
    hours: DEFAULT_ELITE_HOURS,
  },
  'AAF2DBF6-AD62-4FA3-89AC-88D17FC23990': {
    ...DEFAULT_SUPPORT,
    name: 'Inbound - CS',
  },
  'E78C0C45-2ED5-423D-A018-33F5D1C1B420': {
    ...DEFAULT_SUPPORT,
    name: 'INBOUND TEAM',
    hours: DEFAULT_ELITE_HOURS,
  },
  '5A9FC0E0-47C0-4E17-ACEC-02715B4E9CF1': {
    ...DEFAULT_SUPPORT,
    name: 'MEGA',
    phone: '855-725-2867',
  },
  '29F93CAD-E6AF-44C0-8F81-AE40987918FF': {
    ...DEFAULT_SUPPORT,
    name: 'Midbound',
  },
  '7C5D72D8-C187-4D02-8A04-D2165B61333E': {
    ...DEFAULT_SUPPORT,
    name: 'Outbound - CS',
  },
  '1385F7F8-0D6E-4DE0-A413-AF2BBF6DFACF': {
    ...DEFAULT_SUPPORT,
    name: 'OUTBOUND TEAM',
    hours: DEFAULT_ELITE_HOURS,
  },
  'C83FA778-7EE3-413D-B3D6-B44B7F5DBD54': {
    ...DEFAULT_SUPPORT,
    name: 'PRODUCT TEAM',
  },
  'D27E95F5-77E3-4DEC-9124-E942F4BA0DD9': {
    ...DEFAULT_SUPPORT,
    name: 'Regional',
  },
  '472F8D25-39EA-4AAC-A17C-9E2FB78C3EA3': {
    ...DEFAULT_SUPPORT,
    name: 'Team Alex',
  },
  '8F611D27-948B-46CF-8D3F-67C93C7F1A48': {
    ...DEFAULT_SUPPORT,
    name: 'Team Allyson',
  },
  '19B4AEE6-B88D-4BFA-9257-FE03880291B8': {
    ...DEFAULT_SUPPORT,
    name: 'Team Blue',
  },
  '4033F9B8-248E-48FE-9B91-7A99344E3102': {
    ...DEFAULT_SUPPORT,
    name: 'Team Grant',
  },
  '74501FF7-31CB-4974-BDAF-2C99F04E9739': {
    name: 'Team Katie',
    phone: '(704) 944-8692',
    email: 'Katie.Girouard@lendingtree.com',
    hours: 'Monday-Friday 8:30am-5pm PST',
  },
  'B7F628DA-C0FB-48C4-B9EF-6B0B1141588E': {
    name: 'Team Keith',
    phone: '(704) 943-8259',
    email: 'Leonard.Baltazar@lendingtree.com',
    hours: 'Monday-Friday 8:30am-5pm PST',
  },
  'B56DDC75-7307-4F90-B153-CC07442870D8': {
    name: 'Team Megan',
    phone: '(704) 943-8779',
    email: 'Megan.Black@lendingtree.com',
    hours: 'Monday-Friday 8:30am-5pm PST',
  },
  '8302EF54-126D-4A04-AAD3-F57685F0473F': {
    ...DEFAULT_SUPPORT,
    name: 'Team Red',
  },
  'AC42B8CE-1190-41A4-9C3A-2F156CC4B5BA': {
    name: 'Team Spock',
    phone: '(206) 753-2798',
    email: 'Anthony.Darnell@lendingtree.com',
    hours: 'Monday-Friday 8:30am-5pm PST',
  },
  '582728F0-C7F3-46D0-AED2-00C371F26064': {
    ...DEFAULT_SUPPORT,
    name: 'WOLF',
    phone: '855-725-2865',
  },
};

export const getSupportTeamById = supportTeamId => {
  const normalizedId = supportTeamId?.toUpperCase();
  return SupportTeams?.[normalizedId] ?? DEFAULT_SUPPORT;
};
